import http from '../common/http';
import env from '../envConfig';
import { getHeader, getHeaderIdPositiva, getHeaderRotasAbertas } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';
import queryString from 'query-string';

export const obterComprovanteCadastro = async (dados: any, representanteLegal: boolean = false) => {
  let url = env.urlApi + `/transacional-api/v1/pdf/${dados.numeroFamiliar}/comprovante-cadastro/${dados.identificador}/${dados.cpfSolicitante}?`;
  url += `representanteLegal=${representanteLegal}`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const exportarConsultaCompleta = async (dados: any) => {
  let url = env.urlApi + `/transacional-api/v1/pdf/${dados.cpf}/${dados.numeroFamiliar}/exportar-consulta-completa`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const obterComprovanteCadastroIdPositiva = async (numeroFamiliar: number, identificador: number, representanteLegal: boolean = false) => {
  let url = env.urlApi + `/transacional-api/v1/pdf/${numeroFamiliar}/comprovante-cadastro/${identificador}?`;
  url += `representanteLegal=${representanteLegal}`;
  const headers = getHeaderIdPositiva();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const validarComprovante = async (data: any) => {
  let url = env.urlApi + `/transacional-api/v1/pdf`;
  const headers = getHeaderRotasAbertas();

  let formatedData = queryString.stringify(data);
  url += `?${formatedData}`;

  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const downloadCopiaComprovantePorCodigoValidacao = async (codigoValidacao: string) => {
  const url = env.urlApi + `/transacional-api/v1/pdf/${codigoValidacao}/download-comprovante-cadastro`;
  const headers = getHeaderRotasAbertas();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};
